import styled from "styled-components";
import { SwipeableDrawer } from "@mui/material";

export const Container = styled.div`
  width: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const ContainerLeft = styled.div`
  width: 70%;
  background-color: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #d5d5d5;
  padding: 24px;
`;

export const ContainerRight = styled.div`
  width: 30%;
  background-color: #eaefff;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  padding: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  padding: 0 8px;
`;

export const Title = styled.h1`
  color: #4361ee;
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const Title2 = styled.h1`
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #424248;
`;

export const Title3 = styled.h1`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #424248;
`;
export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ContactCount = styled.div`
  text-align: right;
  font-size: 14px;
  padding: 0 8px;
  span {
    font-weight: 600;
  }
`;

export const ContactCountText = styled.p`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: right;
`;

export const ContactInfoText = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: right;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
  background: transparent;
`;

export const Th = styled.th`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  vertical-align: middle;
  padding: 20px 16px;
  text-align: left;
  background: #f8f9fa;
  color: #000000de;
  &:first-child {
    padding-left: 24px;
    border-radius: 8px 0 0 8px;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 2px;
  background: #2d5bff;
`;

export const Td = styled.td`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  padding: 10px 16px;
  background: white;
  color: #101828;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    padding-left: 24px;
    border-radius: 8px 0 0 8px;
    border-left: 1px solid #e0e0e0;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
    border-right: 1px solid #e0e0e0;
  }
  tr:hover & {
    background: #f8f9fa;
  }
`;

export const ProjectImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  background: #f8f9fa;
`;

export const ProjectCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
`;

export const Status = styled.span`
  color: #0091ff;
  font-weight: 500;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-child {
    color: #2d5bff;
  }
  &:last-child {
    color: #ff4d4d;
  }
  &:hover {
    opacity: 0.8;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0 12px 0;
`;

export const ContainerData = styled.div`
  background-color: #ffffff;
  padding: 24px;
  border-radius: 8px;
  border-width: 1px;
  border-color: #d0d5dd;
  border-style: solid;
`;

export const DataHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const DataLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BigNumber = styled.h1`
  font-family: Inter;
  font-weight: 700;
  font-size: 28px;
  line-height: 1;
  color: #101828;
  margin: 0;
`;

export const DataLabel = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #475467;
  margin: 0;
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #eff4ff;
  border: 1px solid #b2ccff;
  border-radius: 8px;
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  color: #4361ee;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;

  white-space: nowrap;

  &:hover {
    background-color: #e1edff;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #f04438;
  color: white;
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 12px;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const DataInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    width: 25px;
    height: 25px;
    color: #667085;
    flex-shrink: 0;
  }
`;

export const InfoText = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #475467;
`;

export const InfoNumber = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.5;
  color: #101828;
`;

export const TitleData = styled.h1`
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  margin-bottom: 6px;
  color: #424248;
  line-height: 1.2;
`;

export const NewCampaignButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
  width: 100%;
  padding: 16px;
  background: #2d5bff;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  margin-top: 24px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
  width: 100%;
  padding: 16px;
  background: #eaefff;
  border: none;
  border-radius: 8px;
  color: #2d5bff;
  cursor: pointer;
  margin-top: 24px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export const StyledSwipeableDrawer = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    width: 400px;
    border-radius: 16px 0 0 16px;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  }
`;
